<template>
  <v-dialog v-model="openDialog" fullscreen>
    <v-card class="fullscreen-dialog">
      <v-container>
        <v-row class="payment-container" align="center" justify="center">
          <v-col cols="8 mb-15">
            <div class="card text-center">
              <h1 class="grey--text mb-7 text-center">O documento selecionado<br/> não possui boleto disponível.</h1>
            </div>

            <v-btn
              class="py-6 payment-button mt-8" 
              block  
              @click="goBack"
              @click.right="goBack"
              color="primary"
            >
              <v-icon left light color="white" size="24" class="mr-2">
                mdi-arrow-left
              </v-icon>

              Voltar
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
        
    </v-card>



  </v-dialog>
</template>

<script>

import {signOut} from "@/controllers/user.controller"

export default {
    name: "PaymentDialog",
    components: {},
    props: {
      openDialog: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        handleSetTimeout: '',
        time: 240000
      }
    },
    methods: {
    goBack () {
      clearTimeout(this.handleSetTimeout)
      this.$emit('close')
    },
    handleSetTimeoutOutput () {
      clearTimeout(this.handleSetTimeout)
      signOut()
    },
  },
  mounted () {
    this.handleSetTimeout = setTimeout(this.handleSetTimeoutOutput, this.time);
  },
}
</script>



<style scoped>
::v-deep .v-text-field__slot  {
  height: 66px;
  font-size: 21px;
  font-weight: bold;
}

::v-deep .v-input__icon {
  align-self: center;
  font-size: 21px;
  margin-top: 5px;
}
::v-deep .v-messages__message  {
  font-size: 16px;
}

/* .fullscreen-dialog {
    background: rgba(12, 204, 166, 0.6) !important;
    box-shadow: 0px 6px 0px rgba(255, 255, 255, 0.4), 0px 0px 32px rgba(35, 41, 46, 0.2) !important;
    backdrop-filter: blur(24px) !important;
    border-radius: 0 !important;
} */

.fullscreen-dialog .payment-container {
    height: 100vh;
    
}

.fullscreen-dialog .payment-button {
    box-shadow: 0px 4px 0px rgba(255, 255, 255, 0.4), 0px 6px 16px rgba(35, 41, 46, 0.2) !important;
    border-radius: 16px !important;
    font-weight: 600 !important;
    font-size: 17px !important;
}

h1 {
    font-size: 26px;
    font-weight: 600;
    line-height: 32.76px;
    letter-spacing: 0.15px;
}

</style>

